export const getKpiColorByNetworkIndicator = (networkIndicator, signal) => {
    let color = null
    switch (networkIndicator) {
        case 'RSRP':
            if (signal.rsrp >= -85) color = '#13f739'
            else if (signal.rsrp < -85 && signal.rsrp >= -100) color = 'yellow'
            else if (signal.rsrp < -100 && signal.rsrp >= -110) color = '#f29e18'
            else if (signal.rsrp <= -110) color = 'red'
            break
        case 'RSRQ':
            if (signal.rsrq >= -10) color = '#13f739'
            else if (signal.rsrq < -10 && signal.rsrq >= -15) color = 'yellow'
            else if (signal.rsrq < -15 && signal.rsrq >= -20) color = '#f29e18'
            else if (signal.rsrq <= -20) color = 'red'
            break
        /*
        case 'RSSI':
            if (signal.rssi >= -65) color = '#13f739'
            else if (signal.rssi < -65 && signal.rssi >= -75) color = 'yellow'
            else if (signal.rssi < -75 && signal.rssi >= -85) color = '#f29e18'
            else if (signal.rssi <= -85) color = 'red'
            break
        */
        case 'RSCP':
            if (signal.rscp >= -60) color = '#13f739'
            else if (signal.rscp < -60 && signal.rscp >= -75) color = 'yellow'
            else if (signal.rscp < -75 && signal.rscp >= -85) color = '#f29e18'
            else if (signal.rscp <= -85) color = 'red'
            break
        case 'RSSNR':
            if (signal.rssnr >= 16) color = '#13f739'
            else if (signal.rssnr < 16 && signal.rssnr >= 5) color = 'yellow'
            else if (signal.rssnr < 5 && signal.rssnr >= -5) color = '#f29e18'
            else if (signal.rssnr <= -5) color = 'red'
            break
        default:
            color = 'white'
    }
    return color
}

export const infoIndicators = {
    LTE: [
        {
            color: '#13f739',
            RSRP: '>= -85',
            RSRQ: '>= -10',
            //RSSI: '> -65',
            RSSNR: '>= 16'
        },
        {
            color: 'yellow',
            RSRP: '-86 to -100',
            RSRQ: '-11 to -15',
            //RSSI: '-66 to -75',
            RSSNR: '5 to 15'
        },
        {
            color: '#f29e18',
            RSRP: '-101 to -110',
            RSRQ: '-16 to -20',
            //RSSI: '-76 to -85',
            RSSNR: '-5 to 5'
        },
        {
            color: 'red',
            RSRP: '<= -100',
            RSRQ: '<= -20',
            //RSSI: '-86 to -95',
            RSSNR: '<= -5'
        },
    ],
    WCDMA: [
        {
            color: '#13f739',
            RSCP: '60 to 0',
            'Ec/Io': '0 to -6',
        },
        {
            color: 'yellow',
            RSCP: '-75 to -60',
            'Ec/Io': '-7 to -10',
        },
        {
            color: '#f29e18',
            RSCP: '-85 to -75',
            'Ec/Io': null,
        },
        {
            color: 'red',
            RSCP: '-95 to -85',
            'Ec/Io': '-11 to -20',
        },
    ],
}
